<template>
    <div></div>
</template>

<script>
import { PERFILES} from '@/assets/js/appConstants'; 
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import * as firebase from "firebase/app";
import AuthenticationMixin from '@/assets/js/authenticationMixin.js';


export default {
    mixins: [AuthenticationMixin],
    data:function(){
        return{
            API_URL: process.env.VUE_APP_API_URL
        }
    },
    created(){
        try{
         
            this.limpiarSesion(firebase);
           
            let dataEncoded = this.$route.query.data;
            //let data = atob('dmFsZXJpYUBnbWFpbC5jb218MXxhZG1pbkBlYS5jb20=')
            let data = atob(dataEncoded);
            let dataArr = data.split("|");
            let correoUsuario = dataArr[0];
            let perfil = parseInt(dataArr[1],10);
            let correoAdmin = dataArr[2];

            this.logIn(correoUsuario, perfil, correoAdmin);
        }catch(ex){
            this.$router.replace({name:"login"});
        }
	},
    computed: {
        UserId: {
            get() {
                return this.$store.state.user_id;
            },
            set(value) {
                this.$store.commit('mutateUserId', value);
            }
        },
        User: {
            get() {
                return this.$store.state.user;
            },
            set(value) {
                this.$store.commit('mutateUser', value);
            }
        },
        
    },
    methods: {
       
        logIn: function(correoUsuario, perfil, correoAdmin) {
			var data = {
                "email": correoUsuario,
                "emailAdmin": correoAdmin,
                "personsTypeId": perfil,
                //"FCM_Token": ""
            }
			baseInstanceAxios
				.post(this.API_URL + `/resources/Persons/ValidateLoginAdmin`, data)
				.then(response => {
                 
					if (response.data != null) {
						if(response.data.entity != null){//LOGUEADO CON EXITO
                       
                            this.UserId = response.data.entity.id;
                            this.User = {
                                "id": response.data.entity.id,
                                "firstName": response.data.entity.firstName,
                                "lastName": response.data.entity.lastName,
                                "strFullName": response.data.entity.strFullName,
                                "email": response.data.entity.email,
                                "photo": response.data.entity.photo,
                                "timeZoneName" : response.data.entity.timeZoneName ? response.data.entity.timeZoneName: 'America/Lima',
                                "timeZone" : response.data.entity.timeZone ? response.data.entity.timeZone.value.totalMinutes: 0,
                                "emailAdmin": correoAdmin,
                                "isResponseReceived": response.data.entity.isResponseReceived,
                            };

                            this.$store.commit("mutateIsAdmin", true);
                            this.$store.commit("mutateAuthToken", response.data.entity.userToken);
                            
                            if(perfil == PERFILES.ALUMNO){
                                this.User["birthDate"] = response.data.entity.birthDate;
                                this.User["age"] = parseInt(response.data.entity.strAge,10);
                                this.User["personStudentId"] = response.data.entity.personStudentId;
                                this.User["personsTypeId"] = PERFILES.ALUMNO;

                                this.$store.commit("mutateIsTeacher", false);
                                this.$store.commit("mutateDatosSidebar", {});
                                this.$store.dispatch("updateFlagValidateCalifications",response.data.entity.flagValidateCalifications)

                                if(this.$route.query.class == 1){
                                    this.$router.push({ name: `student-class` }).catch(err => {});
                                }
                                else if(response.data.entity.flagPurchaseHistory){
                                    this.$router.push({ name: `dashboard` }).catch(err => {});
                                }else{
                                    this.$router.replace({path:"/compra/0"}).catch(err => {});
                                }

                                let language = localStorage.getItem("lang") || "es";
                                this.$i18n.locale = language;

                            }else{
                                localStorage.setItem('lang', "en");
                                this.User["personTeacherId"] = response.data.entity.personTeacherId;
                                this.User["totalClassRequest"] = response.data.entity.totalClassRequest;
                                this.User["totalDetail"] = response.data.entity.totalDetail;
                                
                                this.User["personsTypeId"] = PERFILES.PROFESOR;

                                this.$store.commit("mutateIsTeacher", true);
                                this.$store.commit("mutateDatosSidebar", {});
                                this.$store.dispatch("updateFlagPostulant",response.data.entity.flagPostulant)
                                
                                this.$router.replace({name:"teacher/dashboard"})

                                localStorage.setItem('lang', "en");
                                this.$i18n.locale = "en";

                            }
                            
						}else{
                            this.$router.replace({name:"login"});
                        }
                        
					}
				})
                .catch(error => {
                    //debugger;
                    console.log(error); 
                    this.$router.replace({name:"login"}); 
                });
                
		},
    },
};
</script>